import { render } from "./VerifyByEmail.vue?vue&type=template&id=560c2573&scoped=true"
import script from "./VerifyByEmail.vue?vue&type=script&lang=js"
export * from "./VerifyByEmail.vue?vue&type=script&lang=js"

import "./VerifyByEmail.vue?vue&type=style&index=0&id=560c2573&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-560c2573"]])

export default __exports__